import { useEffect, useState } from 'react'

import { KyrgyzstanSearchApi } from 'shared/api/kyrgyzstan/search'
import { getApiErrorMessage } from 'shared/lib/errorText'

interface UseAvailableDatesProps {
  objectId?: string
  visitorsCount?: number
  childrenAges?: number[]
}

export const useAvailableDates = ({
  objectId,
  visitorsCount,
  childrenAges = [],
}: UseAvailableDatesProps) => {
  const childrenAgesKey = childrenAges.join(',')
  const [availableDates, setAvailableDates] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!objectId || !visitorsCount) {
      setAvailableDates([])
      return
    }

    const fetchAvailableDates = async () => {
      const requestChildrenAges = childrenAgesKey
        ? childrenAgesKey.split(',').map(Number)
        : []

      try {
        setIsLoading(true)
        setError(null)
        const { data } = await KyrgyzstanSearchApi.getAvailableDates(objectId, {
          visitors_count: visitorsCount,
          ...(requestChildrenAges.length
            ? { children_ages: requestChildrenAges }
            : {}),
        })

        setAvailableDates(data.data.available_dates)
      } catch (err) {
        const errorMessage = getApiErrorMessage(err)
        setError(errorMessage)
        setAvailableDates([])
      } finally {
        setIsLoading(false)
      }
    }

    void fetchAvailableDates()
  }, [objectId, visitorsCount, childrenAgesKey])

  return {
    availableDates,
    isLoading,
    error,
  }
}
